module.exports = __webpack_public_path__ + "static/media/ico-IDtest.ffcaca0f.svg";